import { apiClient } from '@/lib/api/client'

export type GeographicOption = {
  id: number
  code?: string
  label: string
  name?: string
}

function normalizeOptions(payload: unknown): GeographicOption[] {
  if (Array.isArray(payload)) return payload as GeographicOption[]
  if (payload && typeof payload === 'object' && Array.isArray((payload as { data?: unknown }).data)) {
    return (payload as { data: GeographicOption[] }).data
  }
  return []
}

export const geographicService = {
  async getRegions(): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/regions')
    return normalizeOptions(data)
  },

  async getAreaClusters(regionId?: number): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/area-clusters', { params: regionId != null ? { region_id: regionId } : undefined })
    return normalizeOptions(data)
  },

  async getProvincesByCluster(areaClusterId: number): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/provinces', {
      params: { area_cluster_id: areaClusterId },
    })
    return normalizeOptions(data)
  },

  async getProvinces(): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/provinces')
    return normalizeOptions(data)
  },

  async getTownsByProvince(provinceId: number): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/towns', {
      params: { province_id: provinceId },
    })
    return normalizeOptions(data)
  },

  async getTowns(): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/towns')
    return normalizeOptions(data)
  },
}
